import React from "react";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { Collapse, Fade, FormLabel, GridLegacy, MenuItem } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext, useWatch } from "react-hook-form";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";

function Upsell() {
  const { menukaartVestigingId } = useFormContext();
  const upsell_settings__is_actief = useWatch({ name: "upsell_settings__is_actief" });
  const upsell_settings__noFood_is_actief = useWatch({ name: "upsell_settings__noFood_is_actief" });
  const upsell_settings__noDrinks_is_actief = useWatch({ name: "upsell_settings__noDrinks_is_actief" });
  const upsell_settings__once_is_actief = useWatch({ name: "upsell_settings__once_is_actief" });
  const is_ai_enabled = useWatch({ name: "custom_data.ai.enabled" });

  return (
    <GridLegacy container spacing={1}>
      <GridLegacy container item xs={12}>
        <Card>
          <CardBody>
            <GridLegacy item xs={12}>
              <h3>{getTranslation("vestigingen.form.upsell.title.Upsell", "Upsell")}</h3>
            </GridLegacy>
            <FormSwitchTC
              name={"upsell_settings__is_actief"}
              tDefault={"Upsell actief (overschrijft onderstaande instellingen"}
              tKey={"vestigingen.form.upsell.label.is_actief"}
            />
          </CardBody>
        </Card>
      </GridLegacy>
      {upsell_settings__is_actief ? (
        <>
          {/*<GridLegacy container spacing={1}>*/}
          <GridLegacy container item xs={12}>
            <Card>
              <CardBody>
                <GridLegacy item xs={12}>
                  <h3>{getTranslation("vestigingen.form.upsell.title.noFood", "Geen eten")}</h3>
                </GridLegacy>
                <GridLegacy item xs={12}>
                  <FormLabel>
                    {getTranslation(
                      "vestigingen.form.upsell.helpText.noFood",
                      "Als er in order geen eten is geselecteerd de volgende upsells laten zien"
                    )}
                  </FormLabel>
                </GridLegacy>
                <FormSwitchTC
                  name={"upsell_settings__noFood_is_actief"}
                  tDefault={"Actief"}
                  tKey={"vestigingen.form.upsell.label.noFood_is_actief"}
                />
                {upsell_settings__noFood_is_actief ? (
                  <>
                    <FormTextTC
                      name={"upsell_settings__noFoodTitel"}
                      tDefault={"Titel"}
                      tKey={"vestigingen.form.upsell.label.titel"}
                    />
                    <FormTextTC
                      name={"upsell_settings__noFoodText"}
                      tDefault={"Text"}
                      tKey={"vestigingen.form.upsell.label.text"}
                    />
                    <FormAsyncTC
                      async={{
                        url:
                          "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                          menukaartVestigingId,
                        searchField: "naam",
                      }}
                      key={"upsell_settings__noFoodProductIds" + menukaartVestigingId}
                      multiple={true}
                      name={"upsell_settings__noFoodProductIds"}
                      tDefault={"Producten"}
                      tKey={"vestigingen.form.upsell.label.producten"}
                    />
                  </>
                ) : null}
              </CardBody>
            </Card>
          </GridLegacy>

          <GridLegacy container item xs={12}>
            <Card>
              <CardBody>
                <GridLegacy item xs={12}>
                  <h3>{getTranslation("vestigingen.form.upsell.title.once", "Eenmalig")}</h3>
                </GridLegacy>
                <GridLegacy item xs={12}>
                  <FormLabel>
                    {getTranslation("vestigingen.form.upsell.helpText.once", "Deze upsells maar 1 keer laten zien")}
                  </FormLabel>
                </GridLegacy>
                <FormSwitchTC
                  name={"upsell_settings__once_is_actief"}
                  tDefault={"Actief"}
                  tKey={"vestigingen.form.upsell.label.once_is_actief"}
                />

                {upsell_settings__once_is_actief ? (
                  <>
                    <FormSelectTC
                      name={"upsell_settings__upsellOnFront"}
                      options={[
                        <MenuItem key={"0"} value={0}>
                          {getTranslation("vestigingen.form.upsell.select.menupage", "Show when the menupage opens")}
                        </MenuItem>,
                        <MenuItem key={"1"} value={1}>
                          {getTranslation(
                            "vestigingen.form.upsell.select.shoppingcart",
                            "Show when the shopping cart opens (shows on pay/checkout on large monitors)"
                          )}
                        </MenuItem>,
                      ]}
                      tDefault={"Upsell shown at"}
                      tKey={"vestigingen.form.upsell.label.partial.upsell-on"}
                    />
                    <FormSelectTC
                      name={"upsell_settings__upsell_on_order_mode"}
                      options={[
                        <MenuItem key={"both"} value={"both"}>
                          {getTranslation(
                            "vestigingen.form.upsell.select.eatInAndTakeAway",
                            "Show when the order is either eat in or take away"
                          )}
                        </MenuItem>,
                        <MenuItem key={"eatIn"} value={"eatIn"}>
                          {getTranslation("vestigingen.form.upsell.select.eatIn", "Show when the order is eat in")}
                        </MenuItem>,
                        <MenuItem key={"takeAway"} value={"takeAway"}>
                          {getTranslation(
                            "vestigingen.form.upsell.select.takeAway",
                            "Show when the order is take away"
                          )}
                        </MenuItem>,
                      ]}
                      tDefault={"Upsell orderMode"}
                      tKey={"vestigingen.form.upsell.label.partial.upsell-orderMode"}
                    />
                    <FormTextTC
                      name={"upsell_settings__onceTitel"}
                      tDefault={"Titel"}
                      tKey={"vestigingen.form.upsell.label.titel"}
                    />
                    <FormTextTC
                      name={"upsell_settings__onceText"}
                      tDefault={"Text"}
                      tKey={"vestigingen.form.upsell.label.text"}
                    />
                    <FormAsyncTC
                      async={{
                        url:
                          "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                          menukaartVestigingId,
                        searchField: "naam",
                      }}
                      key={"upsell_settings__onceProductIds" + menukaartVestigingId}
                      multiple={true}
                      name={"upsell_settings__onceProductIds"}
                      tDefault={"Producten"}
                      tKey={"vestigingen.form.upsell.label.producten"}
                    />
                  </>
                ) : null}
              </CardBody>
            </Card>
          </GridLegacy>
          {/*</GridLegacy>*/}
          <GridLegacy alignContent={"flex-start"} container item xs={12}>
            <Card>
              <CardBody>
                <GridLegacy item xs={12}>
                  <h3>{getTranslation("vestigingen.form.upsell.title.noDrinks", "Geen drinken")}</h3>
                </GridLegacy>
                <GridLegacy item xs={12}>
                  <FormLabel>
                    {getTranslation(
                      "vestigingen.form.upsell.helpText.noDrinks",
                      "Als er in order geen drinken is geselecteerd de volgende upsells laten zien"
                    )}
                  </FormLabel>
                </GridLegacy>
                <FormSwitchTC
                  name={"upsell_settings__noDrinks_is_actief"}
                  tDefault={"Actief"}
                  tKey={"vestigingen.form.upsell.label.noDrinks_is_actief"}
                />
                {upsell_settings__noDrinks_is_actief ? (
                  <>
                    <FormTextTC
                      name={"upsell_settings__noDrinksTitel"}
                      tDefault={"Titel"}
                      tKey={"vestigingen.form.upsell.label.titel"}
                    />
                    <FormTextTC
                      name={"upsell_settings__noDrinksText"}
                      tDefault={"Text"}
                      tKey={"vestigingen.form.upsell.label.text"}
                    />
                    <FormAsyncTC
                      async={{
                        url:
                          "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                          menukaartVestigingId,
                        searchField: "naam",
                      }}
                      key={"upsell_settings__noDrinksProductIds" + menukaartVestigingId}
                      multiple={true}
                      name={"upsell_settings__noDrinksProductIds"}
                      tDefault={"Producten"}
                      tKey={"vestigingen.form.upsell.label.producten"}
                    />
                  </>
                ) : null}
              </CardBody>
            </Card>
          </GridLegacy>
        </>
      ) : null}
      <GridLegacy container item xs={12}>
        <Card>
          <CardBody>
            <GridLegacy item xs={12}>
              <h3>{getTranslation("vestigingen.form.upsell.title.Upsell", "AI Upsell settings")}</h3>
            </GridLegacy>
            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.ai.enabled"}
              tDefault={"Enable AI Upsell"}
              tKey={"custom_data.ai.enabled"}
            />

            <Collapse in={is_ai_enabled}>
              <FormSwitchTC
                defaultValue={true}
                name={"custom_data.ai.useUpsellScreens"}
                tKey={"Display AI upsell using upsellscreens"}
              />
              <FormSwitchTC
                defaultValue={true}
                name={"custom_data.ai.useBaksetUpsell"}
                tKey={"Display AI upsell when opening basket"}
              />
              <FormTextTC
                defaultValue={"3"}
                name={"custom_data.ai.max_popups"}
                tDefault={"Max upsell popup count"}
                tKey={"custom_data.ai.max_popups"}
              />
              <FormTextTC
                defaultValue={"4"}
                name={"custom_data.ai.max_suggestions"}
                tDefault={"Max suggestion count"}
                tKey={"custom_data.ai.max_suggestions"}
              />
              <FormTextTC
                defaultValue={"10"}
                name={"custom_data.ai.suggestion_timeout"}
                tDefault={"Min time between suggessions"}
                tKey={"custom_data.ai.suggestion_timeout"}
              />
            </Collapse>
            <Fade in={!is_ai_enabled}>
              <GridLegacy item xs={12}>
                <FormLabel>
                  {getTranslation("vestigingen.form.upsell.helpText.ai_disabled", "AI upsell is disabled")}
                </FormLabel>
              </GridLegacy>
            </Fade>
          </CardBody>
        </Card>
      </GridLegacy>
    </GridLegacy>
  );
}

export default Upsell;
